import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import { findOrderById, confirmOrder } from 'actions/orders';
import { prettyKey } from 'helpers/formatters';
import { getOrderById, getIncludedInGroups } from 'reducers';
import { DATE_TIME_FORMAT } from '../../constants';
import FormError from '../FormError';

class Order extends Component {
  constructor(props) {
    super(props);

    this.confirmOrder = this.confirmOrder.bind(this);

    this.state = {
      success: '',
      error: null,
    };
  }

  get showConfirmButton() {
    const { order } = this.props;

    if (!order) {
      return false;
    }
    if (
      ['affirm', 'affirm2'].includes(order.purchase.charge_type) &&
      order.purchase.status === 'preauth'
    ) {
      return true;
    }
    return false;
  }

  getDateTime(date) {
    if (Date.parse(date)) return moment(date).format(DATE_TIME_FORMAT);
    return '-';
  }

  async confirmOrder() {
    const { confirmOrder, order } = this.props;

    const response = await confirmOrder(order.id, order);
    if (response.status === 200) {
      this.setState({ success: true, error: null });
    } else {
      this.setState({ success: false, error: response.data });
    }
  }

  componentDidMount() {
    const {
      findOrderById,
      match: {
        params: { id },
      },
    } = this.props;
    findOrderById(id);
  }

  render() {
    const { order } = this.props;
    const { success, error } = this.state;

    if (!order) {
      return <div>Loading...</div>;
    }

    return (
      <div>
        <h1>Order Details</h1>
        <br />
        <h4>Order</h4>
        <table className="table">
          <thead>
            <tr>
              <th>{prettyKey('id')}</th>
              <th>{prettyKey('user_profile')}</th>
              <th>{prettyKey('direction')}</th>
              <th>{prettyKey('created_at')}</th>
              <th>{prettyKey('confirmed_at')}</th>
              <th>{prettyKey('completed_at')}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{order.id}</td>
              <td>{order.user_profile}</td>
              <td>{order.direction}</td>
              <td>{this.getDateTime(order.created_at)}</td>
              <td>{this.getDateTime(order.confirmed_at)}</td>
              <td>{this.getDateTime(order.completed_at)}</td>
            </tr>
          </tbody>
        </table>
        <br />
        <h4>Purchase</h4>
        <table className="table">
          <thead>
            <tr>
              <th>{prettyKey('id')}</th>
              <th>{prettyKey('status')}</th>
              <th>{prettyKey('charge_type')}</th>
              <th>{prettyKey('purchase_date')}</th>
              <th>{prettyKey('payment_date')}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{order.purchase.id}</td>
              <td>{order.purchase.status}</td>
              <td>{order.purchase.charge_type}</td>
              <td>{this.getDateTime(order.purchase.purchase_date)}</td>
              <td>{this.getDateTime(order.purchase.payment_date)}</td>
            </tr>
          </tbody>
        </table>
        <br />
        <h4>Address</h4>
        <table className="table">
          <thead>
            <tr>
              <th>{prettyKey('full_name')}</th>
              <th>{prettyKey('address1')}</th>
              <th>{prettyKey('address2')}</th>
              <th>{prettyKey('city_state')}</th>
              <th>{prettyKey('zip_code')}</th>
              <th>{prettyKey('phone')}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{order.address.full_name}</td>
              <td>{order.address.address1}</td>
              <td>{order.address.address2}</td>
              <td>{order.address.city_state}</td>
              <td>{order.address.zip_code}</td>
              <td>{order.address.phone}</td>
            </tr>
          </tbody>
        </table>
        <br />
        <h4>Order Lines</h4>
        <table className="table">
          <thead>
            <tr>
              <th>{prettyKey('product')}</th>
              <th>{prettyKey('description')}</th>
              <th>{prettyKey('quantity')}</th>
            </tr>
          </thead>
          <tbody>
            {Boolean(order.order_lines.length) &&
              order.order_lines.map((orderLines, index) => {
                return (
                  <tr key={index}>
                    <td>{orderLines.product}</td>
                    <td>{orderLines.description}</td>
                    <td>{orderLines.quantity}</td>
                  </tr>
                );
              })}
          </tbody>
        </table>
        <br />
        {this.showConfirmButton && (
          <button className="btn btn-default" onClick={this.confirmOrder}>
            Confirm
          </button>
        )}
        <br />
        <br />
        {success && <div className="text-success">Order confirmed.</div>}
        {error && <FormError error={error} />}
      </div>
    );
  }
}

const mapStateToProps = (
  state,
  {
    match: {
      params: { id },
    },
  },
) => ({
  isAdmin: getIncludedInGroups(state, ['ADMIN']),
  order: getOrderById(state, id),
});

const mapDispatchToProps = {
  findOrderById,
  confirmOrder,
};

export default connect(mapStateToProps, mapDispatchToProps)(Order);
